<template>
  <div class="anlysis-box">
    <!--无IOT数据时展示升级按钮跳转服务请求页面  -->
    <div v-if="!equip_data.is_iot_ready" class="overlay">
      <button
        type="button"
        class="btn btn-info waves-effect waves-light"
        style="width: 300px; height: 80px; font-size: 22px"
      >
        <span>{{ $t("建议进行IOT升级") }}</span>
      </button>
    </div>
    <div
      style="
        background: #ffffff;
        height: 100%;
        min-width: 1740px;
        overflow: auto;
        font-size: 18px;
      "
    >
      <div style="background: #003d66; padding: 20px">
        <div  
          class="w-100 d-flex align-items-center justify-content-between mb-2"
        >
          <div class="d-flex">
            <div style="font-weight: 600; font-size: 30px; color: #ffffff">
              {{ $t("Energy saving overview") }}
            </div>
            <div
              v-perm="'device.energy.get'"
              class="set-button cursor-pointer ms-4"
              @click="handleParameters"
            >
              <i
                class="ri-settings-4-line fs-23"
                style="color: rgba(41, 156, 219, 1)"
              ></i>
            </div>
          </div>
          <div style="min-width: 680px" class="d-flex justify-content-between">
            <div class="d-flex align-items-center">
              <div style="margin-right: 10px">
                {{ $t("overview_static.common.industry") }}:
              </div>
              <el-select
                style="width: 250px"
                v-model="value"
                class="m-2"
                disabled
              >
                <el-option
                  v-for="item in industryOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="d-flex align-items-center">
              <div style="margin-right: 10px">{{ $t("Apply") }}:</div>
              <el-select
                style="width: 250px"
                v-model="value1"
                class="m-2"
                disabled
              >
                <el-option
                  v-for="item in applyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>
        </div>
        <div style="width: 100%; display: flex; justify-content: space-around">
          <div
            v-for="(a, i) in topDataTop"
            :key="i"
            :style="{ width: a.width }"
            v-show='a.display'
          >
            <div
              style="
                width: 100%;
                height: 100%;
                background: #ebeff2;
                display: flex;
                align-content: space-between;
                justify-content: space-between;
                padding: 10px;
                box-sizing: border-box;
                border-radius: 4px;
              "
            >
              <div
                :style="{
                  minWidth: '100%',
                  position: 'relative',
                }"
                class="shouyi"
              >
                <div class="w-100 h-100 d-flex justify-content-space-between">
                  <div
                    :class="['shouyi',!isPaperMaking&&'pe-2']"
                    :style="{ width: i == 1 && a.subobj ? '60%' : '100%' }"
                  >
                    <div
                      :style="
                        `width: 100%;
                        color: #606163;
                        font-size: ${styleNum.title_fs}px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;`
                      "
                    >
                      <div>
                        {{ a.title }}{{ $i18n.locale != "ch" ? "(CNY)" : "" }}
                      </div>
                      <div :style="`font-size: 16px;${$i18n.locale == 'ch' ?'white-space: nowrap;':''}`">
                        <span
                          style="
                            color: #495057;
                            padding-right: 5px;
                            text-decoration: underline;
                          "
                          >{{ a.tongbi }}</span
                        ><span :style="{ color: a.tongbiColor }">{{
                          a.tongbiVal
                        }}</span>
                      </div>
                    </div>
                    <div
                      style="
                        width: 100%;
                        display: flex;
                        justify-content: start;
                        align-items: baseline;
                      "
                    >
                      <span
                        style="
                          font-size: 32px;
                          color: #3a4d59;
                          font-weight: 500;
                          padding-right: 5px;
                        "
                        >{{ a.value.num }}</span
                      >
                      <div style="color: #606163; margin-left: 10px">
                        <div style="color: #e15c5e; font-size: 14px">
                          {{ a.value.unit }}
                        </div>
                        <div style="font-size: 18px">{{ a.value.unit1 }}</div>
                      </div>
                    </div>
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                    >
                      <div
                        :style="
                          `width: 100%;
                          display: flex;
                          align-items: baseline;
                          font-size: ${styleNum.title_fs1}px;
                          color: #606163;`
                        "
                      >
                        <div style="display: flex; align-items: baseline">
                          <div>{{ a.text }}</div>
                          <div
                            :style="
                              `color: #495057;
                              font-size: ${styleNum.title_fs2}px;
                              margin-left: 10px;`
                            "
                          >
                            {{ a.subtext }}
                          </div>
                        </div>
                        <div
                          v-if="
                          isPaperMaking ? (i != 0?true:false) :
                            (i == 2 ||
                            i == 1 ||
                            (i == 3 && industry == '电力' && apply === '凝汽器抽真空'))
                          "
                          :style="
                            `${isPaperMaking?'':'margin-left: 5px;'}
                            display: flex;
                            align-items: baseline;`
                          "
                        >
                          <div style="margin-right: 5px">✖️</div>
                          <div>{{ a.subtextname }}</div>
                        </div>
                      </div>

                      <img
                        :style="{ width: styleNum.img_w_h+'px', height: styleNum.img_w_h+'px' }"
                        :src="a.imgurl"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    v-if="i == 1 && a.subobj"
                    style="width: 40%; border-left: 1px solid #c2c6cb"
                    class="d-flex flex-wrap justify-content-around ps-2"
                  >
                
                    <div class="w-100 fs-16" style="color: #3a4d59">
                      <div class="w-100 text-center">
                        {{ a.subobj && a.subobj.title2 }}
                      </div>
                      <div
                        class="w-100 text-center"
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: baseline;
                        "
                      >
                        <div style="font-size: 14px">
                          {{ a.subobj && a.subobj["系统背压改善节煤收益"] }}
                        </div>
                        <div style="font-size: 18px; margin-left: 10px">
                          {{ a.subobj && a.subobj.unit1 }}
                        </div>
                      </div>
                    </div>
                    <div class="w-100 fs-16" style="color: #3a4d59">
                      <div class="w-100 text-center">
                        {{ a.subobj && a.subobj.title1 }}
                      </div>
                      <div
                        class="w-100 text-center"
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: baseline;
                        "
                      >
                        <div style="font-size: 14px">
                          {{ a.subobj && a.subobj["机组电耗改善节煤收益"] }}
                        </div>
                        <div style="font-size: 18px; margin-left: 10px">
                          {{ a.subobj && a.subobj.unit1 }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="background: #ffffff; padding: 20px">
        <p
          style="
            font-weight: 600;
            font-size: 30px;
            line-height: 17px;
            color: #495057;
            margin-top: 20px;
          "
        >
          {{ $t("UN energy saving analysis") }}
        </p>
        <div style="width: 100%; margin-top: 20px; height: 600px">
          <a-row
            style="
              color: #000000;
              height: 600px;
              display: flex;
              justify-content: space-between;
            "
          >
            <a-col
              span="7"
              class="flex-wrap"
              style="
                display: flex;
                background: #ebeff2;
                box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);
                height: 100%;
                padding: 20px 10px;
                align-items: center;
                border-radius: 4px;
              "
            >
              <div style="height: 50%; width: 100%">
                <div style="font-size: 20px; color: #606163">
                  <span
                    :style="{
                      display: language != 'ch' ? 'block' : 'inline-block',
                    }"
                    >{{ $t("Operating status") }}：</span
                  ><span style="color: #35d283">{{ $t("Energy saving") }}</span>
                </div>
                <div
                  :style="{
                    width: '100%',
                    height:
                      language != 'ch'
                        ? 'calc(100% - 150px)'
                        : 'calc(100% - 50px)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }"
                >
                  <img
                    style="width: 249px; height: 200px"
                    :src="imgUrl"
                    alt=""
                  />
                </div>
              </div>

              <a-row
                style="
                  width: 100%;
                  color: #3e4043;
                  height: 50%;
                  line-height: 45px;
                  font-weight: 500;
                  background: #fff;
                  font-size: 19px;
                "
                class="d-flex flex-wrap justify-content-start align-content-start p-2"
              >
                <a-col
                  span="24"
                  style="
                    color: #495057;
                    font-weight: 600;
                    font-size: 24px;
                    padding-left: 10px;
                  "
                  class="mb-3"
                >
                  {{ $t("Unit Information") }}-{{
                    equip_data && equip_data.name
                  }}
                </a-col>
                <a-col
                  span="24"
                  style="
                    height: calc(100% - 107px);
                    overflow: hidden;
                    overflow-y: scroll;
                    display: flex;
                    flex-wrap: wrap;
                  "
                  class="mb-1"
                >
                  <a-col
                    span="12"
                    v-for="(item, i) in deviceInfo"
                    :key="i"
                    style="
                      padding-left: 0;
                      display: flex;
                      align-items: center;
                      justify-content: start;
                      text-align: left;
                      height: 50px;
                    "
                    class="mb-1"
                  >
                    <div
                      class="info-bg text-end pe-2"
                      style="
                        width: 42%;
                        line-height: 50px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                      :title="$t(`${item.name}`)"
                    >
                      {{ $t(`${item.name}`) }}
                    </div>
                    <div
                      class="ms-2"
                      style="
                        width: 58%;
                        text-align: left;
                        margin-left: 10px;
                        line-height: 50px;
                      "
                    >
                      {{ item.value }}
                    </div>
                  </a-col>
                </a-col>
              </a-row>
            </a-col>
            <a-col
              span="10"
              style="
                width: 100%;
                background: #ebeff2;
                box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);
                height: 100%;
                align-items: center;
                border-radius: 4px;
                padding: 20px;
              "
            >
              <div style="background: #fff; width: 100%; height: 100%">
                <div
                  style="
                    font-weight: 400;
                    font-size: 20px;
                    color: #495057;
                    padding: 20px 20px 0;
                  "
                  class="d-flex justify-content-between"
                >
                  <div>
                    {{
                      $t("page.energy_consumption_analysis['机组']") +
                      $t(
                        `month.${moment(monthNum).format("MMM").toLowerCase()}`
                      ) +
                      $t("page.energy_consumption_analysis['节能图表']")
                    }}
                  </div>
                  <div>
                    <el-date-picker
                      v-model="monthNum"
                      type="month"
                      value-format="YYYY-MM"
                      placeholder="选择月份"
                      @change="getEnergyMonthly"
                      :clearable="false"
                      :editable="false"
                    />
                    <!--                    <Multiselect-->
                    <!--                        class="form-control"-->
                    <!--                        v-model="monthNum"-->
                    <!--                        placeholder="选择月份"-->
                    <!--                        value-prop="id"-->
                    <!--                        label="name"-->
                    <!--                        :close-on-select="false"-->
                    <!--                        :searchable="false"-->
                    <!--                        :create-option="true"-->
                    <!--                        :options="monthList"-->
                    <!--                        @change="getEnergyMonthly"-->
                    <!--                    />-->
                  </div>
                </div>
                <div style="width: 100%; height: 490px" id="chart9"></div>
              </div>
            </a-col>
            <a-col span="6" style="height: 100%">
              <a-row
                style="
                  height: 100%;
                  display: flex;
                  flex-wrap: wrap;
                  box-sizing: border-box;
                "
              >
                <a-col
                  style="
                    height: 49%;
                    background: #ebeff2;
                    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);
                    border-radius: 4px;
                    margin: 5px;
                    box-sizing: border-box;
                    margin-top: 0;
                  "
                  span="11"
                >
                  <div style="padding: 10px; display: flex; height: 100%">
                    <div
                      style="
                        display: flex;
                        align-content: space-between;
                        height: 100%;
                        flex-wrap: wrap;
                      "
                    >
                      <div
                        :style="
                          `width: 100%;
                          font-weight: 500;
                          font-size: ${styleNum.title_fs}px;
                          color: #606163;
                          display: flex;`
                        "
                      >
                        <p
                          style="width: 80%; min-height: 60px; min-height: 60px"
                        >
                          {{
                            $t(
                              `month.${moment(monthNum)
                                .format("MMM")
                                .toLowerCase()}`
                            ) +
                            $t("page.energy_consumption_analysis['节约电费']")
                          }}({{ $t("Rmb") }})
                        </p>
                        <img
                         :style="{width: styleNum.img_w_h +'px', height: styleNum.img_w_h +'px', marginLeft: '10px'}"
                          src="./Iconshandian.png"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 32px;
                          color: #606163;
                        "
                      >
                        {{
                          (energyMonthlyData["节约电费"] !== "NAN" &&
                          (isPaperMaking?energyMonthlyData["节约电费"]:energyMonthlyData["节约电费"].toFixed(3))) ||
                          "NAN"
                        }}
                        <!-- <span style="font-size: 20px">{{ $t("Rmb") }}</span> -->
                      </div>
                      <div
                        style="
                          width: 100%;
                          font-size: 14px;
                          display: flex;
                          justify-content: end;
                          height: 21px;
                        "
                      >
                        <span
                          style="
                            color: #495057;
                            padding-right: 5px;
                            text-decoration: underline;
                          "
                          >{{ $t("link relative ratio") }}</span
                        ><span
                          :style="{
                            color:
                              energyMonthlyData['节约电费-环比'] !== 'NAN' &&
                              energyMonthlyData['节约电费-环比'] > 0
                                ? '#ed5e5e'
                                : '#419a99',
                          }"
                          >{{
                            (energyMonthlyData["节约电费-环比"] !== "NAN" &&
                              energyMonthlyData["节约电费-环比"].toFixed(3) +
                                "%") ||
                            "NAN"
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </a-col>
                <a-col
                  style="
                    height: 49%;
                    background: #ebeff2;
                    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);
                    border-radius: 4px;
                    box-sizing: border-box;
                    margin: 0 5px 5px;
                  "
                  span="11"
                  ><div style="padding: 10px; display: flex; height: 100%">
                    <div
                      style="
                        display: flex;
                        align-content: space-between;
                        height: 100%;
                        flex-wrap: wrap;
                      "
                    >
                      <div
                      :style="
                          `width: 100%;
                          font-weight: 500;
                          font-size: ${styleNum.title_fs}px;
                          color: #606163;
                          display: flex;`
                        "
                      >
                        <p style="width: 80%; min-height: 60px">
                          {{
                            $t(
                              `month.${moment(monthNum)
                                .format("MMM")
                                .toLowerCase()}`
                            ) +
                            (
                              isPaperMaking?$t( "average_power_savings_per_ton_of_Paper" )+"(Kw/T)"
                              :$t( "page.energy_consumption_analysis['减少CO2排放']" )+`(${ $t("Ton") })` 
                            )
                          }}
                        </p>
                        <img
                          :style="{width: styleNum.img_w_h +'px', height: styleNum.img_w_h +'px', marginLeft: '10px'}"
                          src="./paiqiIcon.png"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 32px;
                          color: #606163;
                        "
                      >
                        {{
                          (energyMonthlyData["减少CO2排放"] !== "NAN" &&
                          (isPaperMaking?energyMonthlyData["减少CO2排放"]:energyMonthlyData["减少CO2排放"].toFixed(3))) ||
                          "NAN"
                        }}
                        <!-- <span style="font-size: 20px"></span> -->
                      </div>
                      <div
                        style="
                          width: 100%;
                          font-size: 14px;
                          display: flex;
                          justify-content: end;
                          height: 21px;
                        "
                      >
                        <span
                          style="
                            color: #495057;
                            padding-right: 5px;
                            text-decoration: underline;
                          "
                          >{{ $t("link relative ratio") }}</span
                        ><span
                          :style="{
                            color:
                              energyMonthlyData['减少CO2排放-环比'] !== 'NAN' &&
                              energyMonthlyData['减少CO2排放-环比'] > 0
                                ? '#ed5e5e'
                                : '#419a99',
                          }"
                          >{{
                            (energyMonthlyData["减少CO2排放-环比"] !== "NAN" &&
                              energyMonthlyData["减少CO2排放-环比"].toFixed(3) +
                                "%") ||
                            "NAN"
                          }}</span
                        >
                      </div>
                    </div>
                  </div></a-col
                >
                <a-col
                  style="
                    height: 49%;
                    background: #ebeff2;
                    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);
                    border-radius: 4px;
                    margin: 5px;
                    box-sizing: border-box;
                  "
                  span="11"
                  ><div style="padding: 10px; display: flex; height: 100%">
                    <div
                      style="
                        display: flex;
                        align-content: space-between;
                        height: 100%;
                        flex-wrap: wrap;
                      "
                    >
                      <div
                      :style="
                          `width: 100%;
                          font-weight: 500;
                          font-size: ${styleNum.title_fs}px;
                          color: #606163;
                          display: flex;`
                        "
                      >
                        <p style="width: 80%; min-height: 60px">
                          {{
                            $t(
                              `month.${moment(monthNum)
                                .format("MMM")
                                .toLowerCase()}`
                            ) +
                            $t("page.energy_consumption_analysis['总电费']")
                          }}({{ $t("Rmb") }})
                        </p>
                        <img
                          :style="{width: styleNum.img_w_h +'px', height: styleNum.img_w_h +'px', marginLeft: '10px'}"
                          src="./shandian2.png"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 32px;
                          color: #606163;
                        "
                      >
                        {{
                          (energyMonthlyData["总电费"] !== "NAN" &&
                            (isPaperMaking?energyMonthlyData["总电费"]:energyMonthlyData["总电费"].toFixed(3))) ||
                          "NAN"
                        }}
                        <!-- <span style="font-size: 20px">{{ $t("Rmb") }}</span> -->
                      </div>
                      <div
                        style="
                          width: 100%;
                          font-size: 14px;
                          display: flex;
                          justify-content: end;
                        "
                      >
                        <span
                          style="
                            color: #495057;
                            padding-right: 5px;
                            text-decoration: underline;
                          "
                          >{{ $t("link relative ratio") }}</span
                        ><span
                          :style="{
                            color:
                              energyMonthlyData['总电费-环比'] !== 'NAN' &&
                              energyMonthlyData['总电费-环比'] > 0
                                ? '#ed5e5e'
                                : '#419a99',
                          }"
                          >{{
                            (energyMonthlyData["总电费-环比"] !== "NAN" &&
                              energyMonthlyData["总电费-环比"].toFixed(3) +
                                "%") ||
                            "NAN"
                          }}</span
                        >
                      </div>
                    </div>
                  </div></a-col
                >
                <a-col
                  style="
                    height: 49%;
                    background: #ebeff2;
                    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.14902);
                    border-radius: 4px;
                    margin: 5px;
                    box-sizing: border-box;
                  "
                  span="11"
                  ><div style="padding: 10px; display: flex; height: 100%">
                    <div
                      style="
                        display: flex;
                        align-content: space-between;
                        height: 100%;
                        flex-wrap: wrap;
                      "
                    >
                      <div
                      :style="
                          `width: 100%;
                          font-weight: 500;
                          font-size: ${styleNum.title_fs}px;
                          color: #606163;
                          display: flex;`
                        "
                      >
                        <p style="width: 80%; min-height: 60px">
                          {{
                            $t(
                              `month.${moment(monthNum)
                                .format("MMM")
                                .toLowerCase()}`
                            ) +
                            (isPaperMaking?$t( "page.energy_consumption_analysis['减少CO2排放']" ):$t( "page.energy_consumption_analysis['产生CO2排放']" ))
                          }}({{ $t("Ton") }})
                        </p>
                        <img
                          :style="{width: styleNum.img_w_h +'px', height: styleNum.img_w_h +'px', marginLeft: '10px'}"
                          src="./paiqiIcon.png"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          width: 100%;
                          font-weight: 500;
                          font-size: 32px;
                          color: #606163;
                        "
                      >
                        {{
                          (energyMonthlyData["产生CO2排放"] !== "NAN" &&
                            (isPaperMaking?energyMonthlyData["产生CO2排放"]:energyMonthlyData["产生CO2排放"].toFixed(3))) ||
                          "NAN"
                        }}
                        <!-- <span style="font-size: 20px">{{ $t("Ton") }}</span> -->
                      </div>
                      <div
                        style="
                          width: 100%;
                          font-size: 14px;
                          display: flex;
                          justify-content: end;
                          height: 21px;
                        "
                      >
                        <span
                          style="
                            color: #495057;
                            padding-right: 5px;
                            text-decoration: underline;
                          "
                          >{{ $t("link relative ratio") }}</span
                        ><span
                          :style="{
                            color:
                              energyMonthlyData['产生CO2排放-环比'] !== 'NAN' &&
                              energyMonthlyData['产生CO2排放-环比'] > 0
                                ? '#ed5e5e'
                                : '#419a99',
                          }"
                          >{{
                            (energyMonthlyData["产生CO2排放-环比"] !== "NAN" &&
                              energyMonthlyData["产生CO2排放-环比"].toFixed(3) +
                                "%") ||
                            "NAN"
                          }}</span
                        >
                      </div>
                    </div>
                  </div></a-col
                >
              </a-row>
            </a-col>
          </a-row>
        </div>
      </div>
      <div style="height: 100px"></div>
      <Form
        :industryOptions="industryOptions"
        :applyOptions="applyOptions"
        ref="formModal"
        @refresh="refresh"
      ></Form>
    </div>
  </div>
</template>
<script>
import { chart9 } from "./chart";
import { onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";

import {
  energyAnnual,
  energyMonthly,
  getInstancesDetailId,
  getEnergyConfig,
} from "@/service";
import _ from "loadsh";
// import { chart8, chart9 } from "./chart";
import moment from "moment";

import Form from "./components/form.vue";
export default {
  setup() {
    const route = useRoute();
    const equip_data = reactive({});
    const data = localStorage.getItem("equip_id");
    const getInstancesDetail = async () => {
      await getInstancesDetailId({ id: route.query.equip_id || data }).then(
        (res) => {
          if (res && res.payload) {
            Object.assign(equip_data, res.payload);
          }
        }
      );
    };
    const scaleva = ref();
    const bodyScale = () => {
      const devicewidth = document.documentElement.clientWidth;
      // 获取当前分辨率下的可是区域宽度
      // 分母——设计稿的尺寸
      scaleva.value = devicewidth / 1920;
    };
    onMounted(() => {
      bodyScale();
      getInstancesDetail();
      window.onresize = () => {
        return (() => {
          bodyScale();
        })();
      };
    });
    return {
      equip_data,
      scaleva,
      getInstancesDetail,
    };
  },
  name: "EnergyConsumption",
  // props: ["dataInfo"],
  components: {
    Form,
  },
  data() {
    return {
      dataInfo:{},
      energyConfigs: {},
      energyAnnualData: {
        CO2排放收益: "NAN",
        "CO2排放收益-同比": "NAN",
        减少的CO2排放量: "NAN",
        节煤总量: "NAN",
        节煤收益: "NAN",
        "节煤收益-同比": "NAN",
        节电总量: "NAN",
        节电收益: "NAN",
        "节电收益-同比": "NAN",
        年度总收益: "NAN",
        "年度总收益-同比": "NAN",
        预测性维护节省收益: "NAN",
        机组电耗改善节煤收益: "NAN",
        系统背压改善节煤收益: "NAN",
        节水收益: "NAN",
        节水量: "NAN",
        "节水收益-同比": "NAN",
      },
      energyMonthlyData: {
        产生CO2排放: "NAN",
        "产生CO2排放-环比": "NAN",
        减少CO2排放: "NAN",
        "减少CO2排放-环比": "NAN",
        总电费: "NAN",
        "总电费-环比": "NAN",
        节约电费: "NAN",
        "节约电费-环比": "NAN",
        data: { before: [], after: [] },
      },
      monthNum: moment().format("YYYY-MM"),
      monthList: [
        { name: "1月", id: "1月" },
        { name: "2月", id: "2月" },
        { name: "3月", id: "3月" },
        { name: "4月", id: "4月" },
        { name: "5月", id: "5月" },
        { name: "6月", id: "6月" },
        { name: "7月", id: "7月" },
        { name: "8月", id: "8月" },
        { name: "9月", id: "9月" },
        { name: "10月", id: "10月" },
        { name: "11月", id: "11月" },
        { name: "12月", id: "12月" },
      ],
      value: "",
      value1: "",
      options: [
        {
          value: this.$t('overview_dynamic.industy_dict["电力"]'),
          label: this.$t('overview_dynamic.industy_dict["电力"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["化工"]'),
          label: this.$t('overview_dynamic.industy_dict["化工"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["油气"]'),
          label: this.$t('overview_dynamic.industy_dict["油气"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["通用"]'),
          label: this.$t('overview_dynamic.industy_dict["通用"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["造纸"]'),
          label: this.$t('overview_dynamic.industy_dict["造纸"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["核电"]'),
          label: this.$t('overview_dynamic.industy_dict["核电"]'),
        },
      ],
      options1: [
        {
          value: this.$t('overview_dynamic.industy_dict["凝汽器抽真空"]'),
          label: this.$t('overview_dynamic.industy_dict["凝汽器抽真空"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["飞灰输送"]'),
          label: this.$t('overview_dynamic.industy_dict["飞灰输送"]'),
        },
        {
          value: this.$t('overview_dynamic.industy_dict["烟气脱硫"]'),
          label: this.$t('overview_dynamic.industy_dict["烟气脱硫"]'),
        },
      ],
      data9: {
        ch: [
          "8月'01",
          "8月'03",
          "8月'05",
          "8月'07",
          "8月'09",
          "8月'11",
          "8月'13",
          "8月'15",
          "8月'17",
          "8月'19",
          "8月'21",
          "8月'23",
          "8月'25",
          "8月'27",
          "8月'29",
        ],
        en: [
          "Aug '01",
          "Aug '03",
          "Aug '05",
          "Aug '07",
          "Aug '09",
          "Aug '11",
          "Aug '13",
          "Aug '15",
          "Aug '17",
          "Aug '19",
          "Aug '21",
          "Aug '23",
          "Aug '25",
          "Aug '27",
          "Aug '29",
        ],
      },
    };
  },
  computed: {
    //字体大小
    styleNum(){
       return  this.isPaperMaking?{
        title_fs:18,
        title_fs1:14,
        title_fs2:14,
        img_w_h:38,
       }:{
        title_fs:20,
        title_fs1:16,
        title_fs2:18,
        img_w_h:48,
       };
    },
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },    
    language() {
      return localStorage.getItem("language") || "ch";
    },
    //造纸厂展示内容12,13,14
    paper_marking(){
      let day = [
        "3,264,831",
        "1,676,500",
        3352968,
        "1,320,231",
        1056.18,
        "254,600",
        2767.2,
        "13,500",
        6759,
      ]
      let m_data =[
        "157,500",
        "29.25",
        "247,400",
        "259.94",
      ]
      let after = [
        {"date": "2025-4-01", "value": 45697},
        {"date": "2025-4-02", "value": 41778},
        {"date": "2025-4-03", "value": 40321},
        {"date": "2025-4-04", "value": 41541},
        {"date": "2025-4-05", "value": 47034},
        {"date": "2025-4-06", "value": 46498},
        {"date": "2025-4-07", "value": 46659},
        {"date": "2025-4-08", "value": 42578},
        {"date": "2025-4-09", "value": 46753},
        {"date": "2025-4-10", "value": 50124},
        // {"date": "2025-4-11", "value": 45893},
        // {"date": "2025-4-12", "value": 45893},
        // {"date": "2025-4-13", "value": 45893},
      ]
      const diff = moment().diff(moment('2025-04-10'), 'days')

      
      if ((diff - 1)>0&&diff<7) {
        for (let i = 0; i < (diff-1); i++) {
            after.push({
              "date": `2025-4-${10+(i+1)}`, "value": 45893
            })
        }
      }
      const todayStr = moment().format('YYYY-MM-DD');
      if(['2025-04-13'].includes(todayStr)){
        day = [
          "3,309,437.4", //+44606.4
          "1,699,400",//+22900
          3398861,//+45893
          "1,338,301",//+18070
          1070.64,//+14.46
          "258,100",//+3500
          2805.08,//+37.88
          "13,636.4",//+136.4
          6827.2,//+68.2
        ]
        m_data = [
          "171,400",//+13900
          "29.25",//+0
          "270,300",//22900
          "297.82",//37.88
        ]
      }else if(['2025-04-14'].includes(todayStr) || moment().isAfter(moment('2025-04-14'))){
        day = [
          "3,354,043.8",
          "1,722,300",
          3444754,
          "1,356,371",
          1085.1,
          "261,600",
          2842.96,
          "13,772.8",
          6895.4,
        ] 
        m_data = [
          "185,300",
          "29.25",
          "293,200",
          "335.7",
        ]
      }
      return {
        to_data_top:[
          {
            display:true,
            width: "19%",
            title: this.$t("annual_energy_savings_of_intelligent_systems"), //智能系统年度节能总收益
            value: {
              num:day[0],
              unit: "",
              unit1: this.$t("Rmb"),
            },
            text: "",
            subtext: "",
            tongbi: this.$t("Year-on-year"),//同比
            tongbiColor:"#ed5e5e",
            tongbiVal:"+13%",
            imgurl: require("./dollar.png"),
          },
          {
              display:true,
              width: "19%",
              title: this.$t("annual_electricity_savings_of_intelligent_systems"),//智能系统年度节电收益
              value: {
                num:day[1],
                unit: "",
                unit1: this.$t("Rmb"),
              },
              text: this.$t("Total power saving"), //节电总量
              subtext: `${day[2]} KW·H`, 
              subtextname: this.$t("tiered_electricity_pricing"),//分段电价
              tongbi: this.$t("Year-on-year"),
              tongbiColor:"#ed5e5e",
              tongbiVal: "+9%",
              imgurl: require("./Iconshandian.png"),
          },
          {
            display:true,
            width: "19%",
            title: this.$t("annual_coal_savings_of_intelligent_systems"),//智能系统年度节煤收益
            value: {
              num:day[3],
              unit: "",
              unit1: this.$t("Rmb"),
            },
            text: this.$t("Total coal saving"),//节煤总量
            subtext: `${day[4]} ${this.$t("Ton")}`, 
            subtextname: this.$t("Coal price today"),//今日煤价
            tongbi: this.$t("Year-on-year"),
            tongbiColor:"#ed5e5e",
            tongbiVal:  "+16%",
            imgurl: require("./dollar.png"),
          },
          {
            display:true,
            width: "19%",
            title: this.$t("annual_co2_reduction_of_intelligent_systems"),//智能系统年度CO₂排放收益
            value: {
              num:day[5],
              unit: "",
              unit1: this.$t("Rmb"),
            },
            text: this.$t("Reduced CO2 emissions"), //减少的CO₂排放量
            subtext:`${day[6]} ${this.$t("Ton")}`,
            subtextname: this.$t("CO2_price"),//CO₂价格
            tongbi: this.$t("Year-on-year"),
            tongbiColor: "#ed5e5e",
            tongbiVal:  "+12%",
            imgurl: require("./dollar.png"),
          },
          {
            display:true,
            width: "19%",
            title: this.$t("annual_water_savings_of_intelligent_systems"), //智能系统年度节水收益
            value: {
              num:day[7],
              unit: "",
              unit1: this.$t("Rmb"),
            },
            text: this.$t("total_wate_saving"), //节水总量
            subtext: `${day[8]} ${this.$t("Ton")}`,
            subtextname: this.$t("current_water_price"), //水价
            tongbi: this.$t("Year-on-year"),
            tongbiColor: "#ed5e5e",
            tongbiVal:   "+11%",
            imgurl: require("./shui.png"),
          },
        ],
        monthly_data:{
          节约电费: m_data[0],
          "节约电费-环比": "NAN",
          减少CO2排放: m_data[1],//平均吨纸电耗节省
          "减少CO2排放-环比": "NAN",
          总电费: m_data[2],
          "总电费-环比": "NAN",
          产生CO2排放: m_data[3] , //减少CO2排放
          "产生CO2排放-环比": "NAN",
          data: {
              before: [
                {"date": "2025-4-01", "value": 73622.22},
                {"date": "2025-4-02", "value": 73622.22},
                {"date": "2025-4-03", "value": 73622.22},
                {"date": "2025-4-04", "value": 73622.22},
                {"date": "2025-4-05", "value": 73622.22},
                {"date": "2025-4-06", "value": 73622.22},
                {"date": "2025-4-07", "value": 73622.22},
                {"date": "2025-4-08", "value": 73622.22},
                {"date": "2025-4-09", "value": 73622.22},
                {"date": "2025-4-10", "value": 73622.22},
                {"date": "2025-4-11", "value": 73622.22},
                {"date": "2025-4-12", "value": 73622.22},
                {"date": "2025-4-13", "value": 73622.22},
                {"date": "2025-4-14", "value": 73622.22},
                {"date": "2025-4-15", "value": 73622.22},
                {"date": "2025-4-16", "value": 73622.22},
                {"date": "2025-4-17", "value": 73622.22},
                {"date": "2025-4-18", "value": 73622.22},
                {"date": "2025-4-19", "value": 73622.22},
                {"date": "2025-4-20", "value": 73622.22},
                {"date": "2025-4-21", "value": 73622.22},
                {"date": "2025-4-22", "value": 73622.22},
                {"date": "2025-4-23", "value": 73622.22},
                {"date": "2025-4-24", "value": 73622.22},
                {"date": "2025-4-25", "value": 73622.22},
                {"date": "2025-4-26", "value": 73622.22},
                {"date": "2025-4-27", "value": 73622.22},
                {"date": "2025-4-28", "value": 73622.22},
                {"date": "2025-4-29", "value": 73622.22},
                {"date": "2025-4-30", "value": 73622.22}
              ],
              after,
            
          }

        },     
      }
    },
    topDataTop() {
      return this.industry == "电力" && this.apply === "凝汽器抽真空"
        ? [
            {
              display:true,
              width: this.energyConfigs.water_config&&this.energyConfigs.water_config['空冷']?"16%":"19%",

              title: this.$t(
                "page.energy_consumption_analysis['智能系统年度总收益']"
              ),
              value: {
                num:
                  this.energyAnnualData["年度总收益"] !== "NAN"
                    ? Number(this.energyAnnualData["年度总收益"].toFixed(3))
                    : "NAN",
                unit: "",
                unit1: this.$t("ten thousands"),
              },
              text: "",
              subtext: "",
              tongbi: this.$t("Year-on-year"),
              tongbiColor:
                this.energyAnnualData["年度总收益-同比"] !== "NAN" &&
                this.energyAnnualData["年度总收益-同比"] > 0
                  ? "#ed5e5e"
                  : "#419a99",
              tongbiVal:
                this.energyAnnualData["年度总收益-同比"] !== "NAN"
                  ? Number(
                      this.energyAnnualData["年度总收益-同比"].toFixed(3)
                    ) + " %"
                  : "NAN",
              imgurl: require("./dollar.png"),
            },
            {
              display:true,
              width: this.energyConfigs.water_config&&this.energyConfigs.water_config['空冷']?"26%":"30%",
              title: this.$t("SA coal saving income"),
              value: {
                num:
                  this.energyAnnualData["节煤收益"] !== "NAN"
                    ? Number(this.energyAnnualData["节煤收益"].toFixed(3))
                    : "NAN",
                unit: "",
                unit1: this.$t("ten thousands"),
              },
              text: this.$t("Total coal saving"),
              subtext:
                this.energyAnnualData["节煤总量"] !== "NAN"
                  ? Number(this.energyAnnualData["节煤总量"].toFixed(3)) +
                    this.$t("Ton")
                  : "NAN",
              subtextname: this.$t("Coal price today"),
              tongbi: this.$t("Year-on-year"),
              tongbiColor:
                this.energyAnnualData["节煤收益-同比"] !== "NAN" &&
                this.energyAnnualData["节煤收益-同比"] > 0
                  ? "#ed5e5e"
                  : "#419a99",
              tongbiVal:
                this.energyAnnualData["节煤收益-同比"] !== "NAN"
                  ? Number(this.energyAnnualData["节煤收益-同比"].toFixed(3)) +
                    "%"
                  : "NAN",
              imgurl: require("./meiqi.png"),
              subobj: {
                title1: this.$t("unit_electricity_consumption_improvement_and_coal_savings_benefits"),
                机组电耗改善节煤收益:
                  this.energyAnnualData["机组电耗改善节煤收益"] !== "NAN"
                    ? Number(
                        this.energyAnnualData["机组电耗改善节煤收益"].toFixed(3)
                      )
                    : "NAN",
                title2: this.$t("system_back_pressure_improves_cs"),
                系统背压改善节煤收益:
                  this.energyAnnualData["系统背压改善节煤收益"] !== "NAN"
                    ? Number(
                        this.energyAnnualData["系统背压改善节煤收益"].toFixed(3)
                      )
                    : "NAN",
                unit1: this.$t("ten thousands"),
              },
            },
            {
              display:true,
              width: this.energyConfigs.water_config&&this.energyConfigs.water_config['空冷']?"21%":"25%",
              title: this.$t("SA CO2 emission benefit"),
              value: {
                num:
                  this.energyAnnualData["CO2排放收益"] !== "NAN"
                    ? Number(this.energyAnnualData["CO2排放收益"].toFixed(3))
                    : "NAN",
                unit: "",
                unit1: this.$t("ten thousands"),
              },
              text: this.$t("Reduced CO2 emissions"),
              subtext:
                this.energyAnnualData["减少的CO2排放量"] !== "NAN"
                  ? Number(
                      this.energyAnnualData["减少的CO2排放量"].toFixed(3)
                    ) + this.$t("Ton")
                  : "NAN",
              subtextname: this.$t("CO2 price today"),
              tongbi: this.$t("Year-on-year"),
              tongbiColor:
                this.energyAnnualData["CO2排放收益-同比"] !== "NAN" &&
                this.energyAnnualData["CO2排放收益-同比"] > 0
                  ? "#ed5e5e"
                  : "#419a99",
              tongbiVal:
                this.energyAnnualData["CO2排放收益-同比"] !== "NAN"
                  ? Number(
                      this.energyAnnualData["CO2排放收益-同比"].toFixed(3)
                    ) + "%"
                  : "NAN",
              imgurl: require("./paiqiIcon.png"),
            },
            {
              display:this.energyConfigs.water_config&&this.energyConfigs.water_config['空冷'],
              width: "15%",
              title: this.$t('page.energy_consumption_analysis["节水收益"]'),
              value: {
                num:
                  this.energyAnnualData["节水收益"] !== "NAN"
                    ? Number(this.energyAnnualData["节水收益"].toFixed(3))
                    : "NAN",
                unit: "",
                unit1: this.$t("ten thousands"),
              },
              text: this.$t("节水量"),
              subtext:
                this.energyAnnualData["节水量"] !== "NAN"
                  ? Number(this.energyAnnualData["节水量"].toFixed(3)) +
                    this.$t("Ton")
                  : "NAN",
              subtextname: this.$t("水费单价"),
              tongbi: this.$t("Year-on-year"),
              tongbiColor:
                this.energyAnnualData["节水收益-同比"] !== "NAN" &&
                this.energyAnnualData["节水收益-同比"] > 0
                  ? "#ed5e5e"
                  : "#419a99",
              tongbiVal:
                this.energyAnnualData["节水收益-同比"] !== "NAN"
                  ? Number(this.energyAnnualData["节水收益-同比"].toFixed(3)) +
                    "%"
                  : "NAN",
              imgurl: require("./shui.png"),
            },
            {
              display:true,
              width: this.energyConfigs.water_config&&this.energyConfigs.water_config['空冷']?"15%":"18%",
              title: this.$t("Predictive maint saves benefits"),
              value: {
                num:
                  this.energyAnnualData["预测性维护节省收益"] !== "NAN"
                    ? Number(
                        this.energyAnnualData["预测性维护节省收益"].toFixed(3)
                      )
                    : "NAN",
                unit: "",
                unit1: this.$t("ten thousands"),
              },
              text: "",
              subtext: "",
              tongbi: "",
              tongbiColor: "#ed5e5e",
              tongbiVal: "",
              imgurl: require("./setting.png"),
            },
          ]
        : (this.isPaperMaking ? this.paper_marking.to_data_top:
            [
              {
                display:true,
                width: "24%",
                title: this.$t(
                  "page.energy_consumption_analysis['智能系统年度总收益']"
                ),
                value: {
                  num:
                    this.energyAnnualData["年度总收益"] !== "NAN"
                      ? Number(this.energyAnnualData["年度总收益"].toFixed(3))
                      : "NAN",
                  unit: "",
                  unit1: this.$t("ten thousands"),
                },
                text: "",
                subtext: "",
                tongbi: this.$t("Year-on-year"),
                tongbiColor:
                  this.energyAnnualData["年度总收益-同比"] !== "NAN" &&
                  this.energyAnnualData["年度总收益-同比"] > 0
                    ? "#ed5e5e"
                    : "#419a99",
                tongbiVal:
                  this.energyAnnualData["年度总收益-同比"] !== "NAN"
                    ? Number(
                        this.energyAnnualData["年度总收益-同比"].toFixed(3)
                      ) + "%"
                    : "NAN",
                imgurl: require("./dollar.png"),
              },
              {
                display:true,
                width: "24%",
                title: this.$t(
                  "page.energy_consumption_analysis['机组年度节电收益']"
                ),
                value: {
                  num:
                    this.energyAnnualData["节电收益"] !== "NAN"
                      ? Number(this.energyAnnualData["节电收益"].toFixed(3))
                      : "NAN",
                  unit: "",
                  unit1: this.$t("ten thousands"),
                },
                text: this.$t("Total power saving"),
                subtext:
                  this.energyAnnualData["节电总量"] !== "NAN"
                    ? Number(this.energyAnnualData["节电总量"].toFixed(3)) +
                      " kWh"
                    : "NAN",
                subtextname: this.$t("Electricity price today"),
                tongbi: this.$t("Year-on-year"),
                tongbiColor:
                  this.energyAnnualData["节电收益-同比"] !== "NAN" &&
                  this.energyAnnualData["节电收益-同比"] > 0
                    ? "#ed5e5e"
                    : "#419a99",
                tongbiVal:
                  this.energyAnnualData["节电收益-同比"] !== "NAN"
                    ? Number(this.energyAnnualData["节电收益-同比"].toFixed(3)) +
                      "%"
                    : "NAN",
                imgurl: require("./meiqi.png"),
              },
              {
                display:true,
                width: "24%",
                title: this.$t("SA CO2 emission benefit"),
                value: {
                  num:
                    this.energyAnnualData["CO2排放收益"] !== "NAN"
                      ? Number(this.energyAnnualData["CO2排放收益"].toFixed(3))
                      : "NAN",
                  unit: "",
                  unit1: this.$t("ten thousands"),
                },
                text: this.$t("Reduced CO2 emissions"),
                subtext:
                  this.energyAnnualData["减少的CO2排放量"] !== "NAN"
                    ? Number(
                        this.energyAnnualData["减少的CO2排放量"].toFixed(3)
                      ) + this.$t("Ton")
                    : "NAN",
                subtextname: this.$t("CO2 price today"),
                tongbi: this.$t("Year-on-year"),
                tongbiColor:
                  this.energyAnnualData["CO2排放收益-同比"] !== "NAN" &&
                  this.energyAnnualData["CO2排放收益-同比"] > 0
                    ? "#ed5e5e"
                    : "#419a99",
                tongbiVal:
                  this.energyAnnualData["CO2排放收益-同比"] !== "NAN"
                    ? Number(
                        this.energyAnnualData["CO2排放收益-同比"].toFixed(3)
                      ) + "%"
                    : "NAN",
                imgurl: require("./paiqiIcon.png"),
              },
              {
                display:true,
                width: "24%",
                title: this.$t("Predictive maint saves benefits"),
                value: {
                  num:
                    this.energyAnnualData["预测性维护节省收益"] !== "NAN"
                      ? Number(
                          this.energyAnnualData["预测性维护节省收益"].toFixed(3)
                        )
                      : "NAN",
                  unit: "",
                  unit1: this.$t("ten thousands"),
                },
                text: "",
                subtext: "",
                tongbi: "",
                tongbiColor: "#ed5e5e",
                tongbiVal: "",
                imgurl: require("./setting.png"),
              },
            ]);
    },
    topData() {
      return [
        {
          title: "月累计总电耗",
          value: { num: 4290, unit: "", unit1: "kWh" },
          same: "-14.9",
          sequential: "6",
        },
        {
          title: "本月总电费",
          value: { num: 2450, unit: "", unit1: "万元" },
          same: "-15.3",
          sequential: "5",
        },
        {
          title: "月累计吸气",
          value: { num: 1030, unit: "", unit1: "Nm³" },
          same: "-14.9",
          sequential: "3",
        },
        {
          title: "月吸气电耗",
          value: { num: 4.17, unit: "", unit1: "kWh/Nm³" },
          same: "-14.9",
          sequential: "3",
        },
        {
          title: "月吸气电耗",
          value: { num: 2.08, unit: "", unit1: "元/Nm³" },
          same: "-14.9",
          sequential: "3",
        },
      ];
    },
    deviceInfo() {
      /* 有IOT数据的设备，显示设备出厂信息的字段，包含自定义的字段 */
      let list = [];
      this.equip_data.attributes &&
        this.equip_data.attributes.attributes.map((item) => {
          if (item.group === "设备出厂信息") {
            list.push(item);
          }
        });
      return list;
    },
    // deviceInfo() {
    //   return this.industry=='电力'?[
    //     {name: this.$t("Type"), value: this.equip_data.deviceProfileName},
    //     {name: "最大吸气量", value: "300-1300 m3/h"},
    //     {name: this.$t("Extreme Vacuum"), value: "2.0 kPaA"},
    //     {name: this.$t("Back pressure"), value: "ATM～1200 mbarA"}, //背压
    //     {name: "电机功率", value: "37kw"},
    //     {name: this.$t("Equipment running time"), value: this.$t("362 Days 20 Hours"),},
    //   ]:[
    //     {name: this.$t("Type"), value: this.equip_data.deviceProfileName},
    //     {name: "最大吸气量", value: "300-1300 m3/h"},
    //     {name: this.$t("Extreme Vacuum"), value: "2.0 kPaA"},
    //     {name: "电机功率", value: "37kw"},
    //     {name: this.$t("Equipment running time"), value: this.$t("362 Days 20 Hours"),},
    //   ];
    // },
    imgUrl() {
      return _.get(this.equip_data, ["files", "image", 0, "url"], "");
    },
    industryOptions() {
      let list;
      this.equip_data.attributes &&
        this.equip_data.attributes.attributes.map((item) => {
          if (item.name === "客户行业") {
            list = item.options.map((v) => {
              return { value: v.value, label: this.$t(v.label) };
            });
          }
        });
      return list;
    },
    applyOptions() {
      let list;
      this.equip_data.attributes &&
        this.equip_data.attributes.attributes.map((item) => {
          if (item.name === "应用行业") {
            list = item.options.map((v) => {
              return {
                value: v.value,
                label: this.$t(`overview_dynamic.industy_dict['${v.label}']`),
              };
            });
          }
        });
      return list;
    },
    industry() {
      // let str;
      // this.equip_data.attributes&&this.equip_data.attributes.attributes.map(item=>{
      //   if(item.name==='客户行业'){
      //     str = item.value
      //   }
      // })
      return this.energyConfigs.industry || "";
    },
    apply() {
      // let str;
      // this.equip_data.attributes&&this.equip_data.attributes.attributes.map(item=>{
      //   if(item.name==='应用行业'){
      //     str = item.value
      //   }
      // })
      return this.energyConfigs.use || "";
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.getEnergyMonthly();
      },
      deep: true,
    },

    industry: {
      handler(val) {
        if (val) this.value = val;
      },
      deep: true,
    },
    apply: {
      handler(val) {
        if (val) this.value1 = val;
      },
      deep: true,
    },
    dataInfo: {
      handler(val) {
        if (val && !val.is_iot_ready) {
          this.clearData(val);
        }
      },
      deep: true,
    },
  },
  methods: {
    clearData(val){
      this.energyAnnualData= {
        CO2排放收益: "NAN",
        "CO2排放收益-同比": "NAN",
        减少的CO2排放量: "NAN",
        节煤总量: "NAN",
        节煤收益: "NAN",
        "节煤收益-同比": "NAN",
        节电总量: "NAN",
        节电收益: "NAN",
        "节电收益-同比": "NAN",
        年度总收益: "NAN",
        "年度总收益-同比": "NAN",
        预测性维护节省收益: "NAN",
        机组电耗改善节煤收益: "NAN",
        系统背压改善节煤收益: "NAN",
        节水收益: "NAN",
        节水量: "NAN",
        "节水收益-同比": "NAN",
      }
      this.energyMonthlyData= {
        产生CO2排放: "NAN",
        "产生CO2排放-环比": "NAN",
        减少CO2排放: "NAN",
        "减少CO2排放-环比": "NAN",
        总电费: "NAN",
        "总电费-环比": "NAN",
        节约电费: "NAN",
        "节约电费-环比": "NAN",
        data: { before: [], after: [] },
      }
      let legendData =
                  _.clone(val).energy &&
                  _.clone(val).energy.is_upgrade
                    ? [
                        this.$t("Power before renovation"),
                        this.$t("Power after renovation"),
                      ]
                    : [this.$t("Rated power"), this.$t("Actual power")];
                this.$nextTick(() => {
                  chart9("chart9", legendData, [], [], []);
                });

    },
    /*能耗配置详情*/
    async energyConfigData() {
      const resp = await getEnergyConfig(this.$route.query.equip_id);
      if (resp && resp.payload && resp.payload.cal_config) {
        this.energyConfigs = resp.payload;
      }
    },
    moment,
    /* 能耗参数配置弹框 */
    handleParameters() {
      this.$refs.formModal.open();
    },
    /* 能耗分析没有IOT数据时展示蒙层，点击跳转服务请求页面 */
    toServcePage() {
      
      this.$router.push({
        path: "/repair-request/add",
        query: { id: this.equip_data.customer_id, sn: this.equip_data.root_sn },
      });
    },
    getEnergyAnnual() {
      let params = {
        device_id: this.$route.query.equip_id,
        year: moment().format("YYYY"),
      };
      energyAnnual(params)
        .then((res) => {
          if (res && res.payload) {
            this.energyAnnualData = {
              CO2排放收益: res.payload["CO2排放收益"] ?? "NAN",
              "CO2排放收益-同比": res.payload["CO2排放收益-同比"] ?? "NAN",
              减少的CO2排放量: res.payload["减少的CO2排放量"] ?? "NAN",
              节煤总量: res.payload["节煤总量"] ?? "NAN",
              节煤收益: res.payload["节煤收益"] ?? "NAN",
              "节煤收益-同比": res.payload["节煤收益-同比"] ?? "NAN",
              节电总量: res.payload["节电总量"] ?? "NAN",
              节电收益: res.payload["节电收益"] ?? "NAN",
              "节电收益-同比": res.payload["节电收益-同比"] ?? "NAN",
              年度总收益: res.payload["年度总收益"] ?? "NAN",
              "年度总收益-同比": res.payload["年度总收益-同比"] ?? "NAN",
              预测性维护节省收益: res.payload["预测性维护节省收益"] ?? "NAN",
              机组电耗改善节煤收益:
                res.payload["机组电耗改善节煤收益"] ?? "NAN",
              系统背压改善节煤收益:
                res.payload["系统背压改善节煤收益"] ?? "NAN",
              节水收益: res.payload["节水收益"] ?? "NAN",
              节水量: res.payload["节水量"] ?? "NAN",
              "节水收益-同比": res.payload["节水收益-同比"] ?? "NAN",
            };
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEnergyMonthly(e) {
      getInstancesDetailId({
        id: this.$route.query.equip_id || localStorage.getItem("equip_id"),
      }).then((ress) => {
        this.dataInfo = ress && ress.payload
        if (ress && ress.payload&&ress.payload.is_iot_ready) {
          let params = {
            device_id: this.$route.query.equip_id,
            month: (e && e) || this.monthNum,
          };
          energyMonthly(params)
            .then((res) => {
              if (res && res.payload) {
                //造纸厂展示内容
                if(this.isPaperMaking){ 
                  this.monthNum = "2025-04"
                  this.energyMonthlyData = this.paper_marking.monthly_data
                }else{
                  this.energyMonthlyData = {
                    产生CO2排放: res.payload["产生CO2排放"] ?? "NAN",
                    "产生CO2排放-环比": res.payload["产生CO2排放-环比"] ?? "NAN",
                    减少CO2排放: res.payload["减少CO2排放"] ?? "NAN",
                    "减少CO2排放-环比": res.payload["减少CO2排放-环比"] ?? "NAN",
                    总电费: res.payload["总电费"] ?? "NAN",
                    "总电费-环比": res.payload["总电费-环比"] ?? "NAN",
                    节约电费: res.payload["节约电费"] ?? "NAN",
                    "节约电费-环比": res.payload["节约电费-环比"] ?? "NAN",
                    data: {
                      before: (res.payload.data && res.payload.data.before) || [],
                      after: (res.payload.data && res.payload.data.after) || [],
                    },
                  };
                }
                let monthNum = moment(this.monthNum).daysInMonth();
                let dateObj1 = {};
                let dateObj2 = {};
                let data = [];
                let data1 = [];
                let data2 = [];

                for (let i = 0; i < monthNum; i++) {
                  data.push(i + 1 < 10 ? "0" + (i + 1) : i + 1);
                  dateObj1[
                    moment(this.monthNum).format("MM") +
                      (i + 1 < 10 ? "-0" + (i + 1) : "-" + (i + 1))
                  ] = 0;
                  dateObj2[
                    moment(this.monthNum).format("MM") +
                      (i + 1 < 10 ? "-0" + (i + 1) : "-" + (i + 1))
                  ] = 0;
                }
                // (moment(this.monthNum).daysInMonth()).map(item=>{
                //   data.push(moment(this.monthNum).format('YYYY-M')+item)
                // })
                // console.log(moment(this.monthNum).daysInMonth(),data)

                if (this.energyMonthlyData.data.before) {
                  this.energyMonthlyData.data.before.map((item) => {
                    for (const itemKey in dateObj1) {
                      if (itemKey == moment(item.date).format("MM-DD")) {
                        dateObj1[itemKey] = item.value;
                      }
                    }
                  });
                }
                if (this.energyMonthlyData.data.after) {
                  this.energyMonthlyData.data.after.map((item) => {
                    for (const itemKey in dateObj2) {
                      if (itemKey == moment(item.date).format("MM-DD")) {
                        dateObj2[itemKey] = item.value;
                      }
                    }
                  });
                }
                if (this.energyMonthlyData.data.actual) {
                  this.energyMonthlyData.data.actual.map((item) => {
                    for (const itemKey in dateObj2) {
                      if (itemKey == moment(item.date).format("MM-DD")) {
                        dateObj2[itemKey] = item.value;
                      }
                    }
                  });
                }
                for (const itemKey in dateObj1) {
                  data1.push(dateObj1[itemKey] && dateObj1[itemKey].toFixed(3));
                }
                for (const itemKey in dateObj2) {
                  data2.push(dateObj2[itemKey] && dateObj2[itemKey].toFixed(3));
                }
                let legendData =
                  (_.clone(ress.payload).energy &&  _.clone(ress.payload).energy.is_upgrade)
                  || this.isPaperMaking
                    ? [
                        this.$t("Power before renovation"),
                        this.$t("Power after renovation"),
                      ]
                    : [this.$t("Rated power"), this.$t("Actual power")];
                this.$nextTick(() => {
                  chart9("chart9", legendData, data, data1, data2);
                });
                
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    refresh() {
      Swal.fire({
        title: this.$t("page.submitting"),
        showConfirmButton: false,
      });
      Swal.showLoading();
      setTimeout(() => {
        Swal.close();
        this.getEnergyAnnual();
        this.getEnergyMonthly();
        this.energyConfigData();
      }, 5000);
    },
  },
  mounted() {
    this.getEnergyAnnual();
    this.getEnergyMonthly();
    this.energyConfigData();
  },
};
</script>
<style scoped lang="scss">
.anlysis-box {
  position: relative;
  height: 85%;
  background: #003d66;
  color: #ffffff;
  overflow: auto;
}
// 右侧曲线没有IOT数据时展示蒙层，点击跳转服务请求页面
.contain_mask {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #e0e0e0, $alpha: 0.3);
  border-radius: 10px;
  height: 100%;
  overflow: auto;
}
//蒙层盒子 右侧曲线没有IOT数据时展示蒙层，点击跳转服务请求页
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(73, 87, 135, 0.4); /* 半透明黑色 */
  z-index: 1;
  // cursor: pointer; /* 可选：为蒙层添加鼠标指针样式 */
  display: flex;
  justify-content: center;
  align-items: center;
}

.shouyi {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
}
.info-bg {
  background: #f3f6f9;
}
.scroll-box::-webkit-scrollbar {
  display: none; /* Chrome Safari */
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}
.set-button {
  width: 39px;
  height: 39px;
  text-align: center;
  line-height: 39px;
  background: rgba(41, 156, 219, 0.098);
  border-radius: 5px;
}
</style>
